import {styled} from '@mui/material';
import {forwardRef} from 'react';
import {Divider, DividerProps} from '../Divider';
import {headerCssClassNames} from './headerCssClassNames';

const StyledDivider = styled(Divider)<DividerProps>(({theme}) => ({
    height: '24px',
    marginTop: 'auto',
    marginBottom: 'auto',
    borderColor: theme.tokens.FuelColorBorderBase
}));

export const HeaderDivider = forwardRef<HTMLHRElement, DividerProps>((props, ref) => {
    return (
        <StyledDivider
            {...props}
            className={headerCssClassNames.divider}
            flexItem
            orientation='vertical'
            ref={ref}
        />
    );
});

HeaderDivider.displayName = 'HeaderDivider';
